import axios from "axios";
import type { AxiosResponse } from "axios";

import { headers, host } from "./shared";

type ApiEvent = {
  name: string;
  properties?: Record<string, unknown>;
};

export const createEvent = async (
  event: ApiEvent,
  accessToken?: string | null,
): Promise<AxiosResponse<void>> => {
  return await axios.post(
    `${host}/api/events`,
    { event },
    headers(accessToken),
  );
};
